import type {MantineColorScheme} from '@mantine/core'
import {createContext} from 'react'

export type LocalSettingsContextValue = {
  colorScheme: MantineColorScheme
  setColorScheme: (colorScheme: MantineColorScheme) => void
  compactMode: boolean
  setCompactMode: (compactMode: boolean) => void
  showWeekend: boolean
  setShowWeekend: (showWeekend: boolean) => void
  showRecommendations: boolean
  setShowRecommendations: (showRecommendations: boolean) => void
  mergeRecommendations: boolean
  setMergeRecommendations: (mergeRecommendations: boolean) => void
  roundRecommendationTimes: boolean
  setRoundRecommendationTimes: (roundRecommendationTimes: boolean) => void
}

export const LocalSettingsContext = createContext<LocalSettingsContextValue>({} as LocalSettingsContextValue)
